import Button from '@anm/components/buttons/Button';
import { Title } from '@anm/components/stream/Invite/Wrapper';
import { Wrapper as ModalWrapper } from '@anm/components/stream/InviteGuestsModal';
import { flexRow } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

const ButtonsContainer = styled.div`
  ${flexRow};
  gap: 10px;
  margin-top: 24px;

  button,
  a {
    flex: 1;
    min-width: unset;
    padding: 0;
    font-weight: 700;
    font-size: 16px;
  }
`;

type TSuccessStreamModal = {
  studioLink: string;
  onClose(): void;
  onInvite(): void;
};

const SuccessStreamModal: FC<TSuccessStreamModal> = ({ studioLink, onClose, onInvite }) => (
  <ModalWrapper onModalClose={onClose}>
    <Title
      title="Stream successfully created"
      description="Your event is ready! Now you can invite your guests and setup the Streaming studio"
    />
    <ButtonsContainer>
      <Button variant="silver-border" size="big" onClick={onInvite}>
        Invite Guests
      </Button>
      <Button href={studioLink} variant="silver-border" size="big" target="_self">
        Open studio
      </Button>
      <Button variant="blue-saturated" size="big" onClick={onClose}>
        Done
      </Button>
    </ButtonsContainer>
  </ModalWrapper>
);

export default SuccessStreamModal;
